export { PageFooterTemplate } from './PageFooterTemplate'
export type { PageFooterTemplateProps } from './PageFooterTemplate.types'
